import React, { useState, useEffect } from "react";
import publicAxios from "../../utils/publicAxios";
import "../../assets/scss/login.scss";
import Footerweb from "../../components/layout/footer/Footerweb";
import Headerweb from "../../components/layout/header/Headerweb";
import { Link } from "react-router-dom";
import { showToast } from "../../utils/utils";
import { reset_password } from "../../locales/en";
import { EMAIL_REGEX, showToastType } from "../../utils/constants/appConstants";
import { getForgetPasswordURL } from "../../utils/constants/apiEndPoints";
import { SIGN_UP } from "../../route/paths";

const Reset = () => {
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const initialErrors = {
    email: "",
    general: ""
  };
  const [errors, setErrors] = useState(initialErrors);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors({ email: "", general: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    // Reset errors before validation
    setErrors({ email: "", general: "" });

    // Basic email validation
    if (!email) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: reset_password?.emailError
      }));
      isValid = false;
    } else if (!EMAIL_REGEX.test(email)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: reset_password?.validEmailError
      }));
      isValid = false;
      setErrorMessage("");
    }

    if (isValid) {
      const userData = { email };
      try {
        const response = await publicAxios.post(getForgetPasswordURL, userData);

        if (response.status === 200) {
          setEmailSent(true);
          setErrors({ email: "", general: "" });
          showToast(response.data.message, showToastType.success);
          setErrorMessage("");
        }
      } catch (error) {
        if (error.response?.status === 403) {
          setErrorMessage(reset_password?.accountError);
        } else {
          setErrors({ email: "", general: reset_password?.validEmailError });
          setErrorMessage("");
        }
      }

      setEmail("");
    }
  };

  useEffect(() => {
    if (emailSent) {
      setEmailSent(false);
    }
  }, [emailSent]);

  return (
    <>
      <Headerweb />

      <main>
        <div className="signup-hero-section">
          <div className="container-wrap">
            <div className="hero-content">
              <h1>
                <strong>{reset_password?.main_title1} </strong>
                {reset_password?.main_title2}
              </h1>
            </div>
          </div>
        </div>
        <div className="sign-up-wrap">
          <div className="container-wrap">
            <div className="col-row">
              <div className="center-wrap">
                <div className="sign-up-form reset-password-form">
                  <div className="fundtap-heading">
                    <div className="title-left">
                      <p>{reset_password?.title_left}</p>
                    </div>
                    <div className="signup-btn-right d-flex align-items-center">
                      {reset_password?.or}
                      <Link to={SIGN_UP} className="btn-primary">
                        {reset_password?.sign_up}
                      </Link>
                    </div>
                  </div>
                  <form id="reset_form">
                    <div className="input-row">
                      <div className="input-group">
                        <input
                          type="email"
                          placeholder="Email Address"
                          value={email}
                          name="email"
                          id="email"
                          autoComplete="false"
                          onChange={handleEmailChange}
                        />

                        {errors.email && (
                          <p className="error-message">
                            <small>{errors.email}</small>
                          </p>
                        )}
                        {emailSent && (
                          <div className="small-text text-success mt-1">
                            {reset_password?.mai_sent_message}
                          </div>
                        )}

                        {errors.general && (
                          <p className="error-message">
                            <small>{errors.general}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <button
                          type="submit"
                          className="btn-primary"
                          onClick={handleSubmit}
                        >
                          {reset_password?.submit_btn}
                        </button>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="error-message font-16">
                        {errorMessage}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footerweb />
    </>
  );
};

export default Reset;
